import axios from "axios";

export default {
    async cambiarEstadoDespacho (itemId, nuevoEstado) {
         return axios.put(
            `/api/admin/despachos/change-state/${itemId}`,
             { estado_despacho: nuevoEstado }
         ); 
    },

    async getListaEstadosDespacho () {
        return axios.get(
            "/api/estados-despacho"
        );
    },

    async requestOCR(formData) {
        const config = {
            contentType: "multipart/form-data",
        };
        
        return axios.post(`/api/din-ocr`, formData, config);
    },

    async getList(list = [], extraParams = {}) {
        const query = {
            params: {
                get: JSON.stringify(list),
                ...extraParams
            }
        };

        return axios.get('/api/list', query);
    }
}